<template>
  <div class="page-certificate">
    <div class="page-header">
      <h2>{{ action === 'add' ? '添加' : '修改' }}会员信息</h2>
    </div>
    <div class="page-body">
      <a-form
        class="mod-form"
        layout="horizontal"
        labelAlign="left"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :colon="false"
        :form="form"
        @submit="onSubmit"
      >
        <a-form-item label="证件类型">
          <a-select
            size="large"
            placeholder="请选择证件类型"
            v-decorator="[
              'certType',
              {
                initialValue: certType,
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ]
              }
            ]"
            :disabled="!!id"
            :options="options"
          >
          </a-select>
        </a-form-item>
        <a-form-item label="证件号码">
          <a-input
            size="large"
            placeholder="请输入所选证件的号码"
            v-decorator="[
              'certNo',
              {
                initialValue: certNo,
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
          >
          </a-input>
        </a-form-item>
        <a-form-item label="验证方式">
          <user-verify-type @error="onVerifyTypeError" @change="onVerifyTypeChange"></user-verify-type>
        </a-form-item>
        <a-form-item label="验证码">
          <user-slider-captcha ref="verify" size="large" @change="onCaptchVerify">
          </user-slider-captcha>
        </a-form-item>
        <a-form-item label="手机验证码" v-if="type === 'mobile'">
          <user-verification-code placeholder="请输入手机动态码" size="large" actionText="获取手机动态码" :smsType="11" :value="value" :token="token" @change="onVerificationCodeChange">
          </user-verification-code>
        </a-form-item>
        <a-form-item label="邮箱验证码" v-else>
          <user-verification-code placeholder="请输入邮箱动态码" size="large" actionText="获取邮箱动态码" type="email" :smsType="11" :value="value" :token="token" @change="onVerificationCodeChange">
          </user-verification-code>
        </a-form-item>
        <a-form-item :wrapper-col="wrapperColOffset">
          <a-button style="margin: 0; width: 100%" type="primary" size="large" :loading="loading" html-type="submit">提交</a-button>
        </a-form-item>
      </a-form>
    </div>
    <div class="page-footer">
      <div class="mod-tip">
        <a-icon type="exclamation-circle" theme="filled" />若以上联系方式已失效，您可以先到会员中心页绑定个人手机或邮箱，再进行处理。
        <p v-if="cmsPageTips" v-html="cmsPageTips.warmPromptContent"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep, remove, get } from 'lodash'
import queryString from 'query-string'
import { validate } from '@/utils/validate'
import { verify } from '@/api/verify'
import { certificate } from '@/api/member'
import { getCmsDataFormat } from '@/utils/util'
import eventBus from '../../components/eventBus.js'
import './index'

const certTypeOptions = [
  {
    label: '身份证',
    value: '5'
  },
  {
    label: '有效护照',
    value: '2'
  },
  {
    label: '港澳台居民居住证',
    value: '207'
  },
  {
    label: '台胞证',
    value: '206'
  },
  {
    label: '军官证',
    value: '6'
  },
  {
    label: '士兵证',
    value: '3'
  },
  {
    label: '其他证件',
    value: '14'
  }
]

export default {
  data () {
    return {
      action: 'add',
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 19
      },
      wrapperColOffset: {
        span: 19, offset: 5
      },
      form: this.$form.createForm(this),
      loading: false,
      id: '',
      certType: '5',
      certNo: '',
      token: '',
      finalToken: '',
      code: '',
      value: '',
      type: '',
      options: [],
      errCode: '',
      cmsPageTips: null
    }
  },
  created () {
    const params = queryString.parse(location.search)
    const userInfo = this.$ls.get('USER_CENTER_INFO')

    this.action = params.action || 'add'
    this.id = params.id || ''
    this.certNo = params.certNo || ''

    const options = cloneDeep(certTypeOptions)

    if (!params.certType && userInfo.userCerts && userInfo.userCerts.length) {
      userInfo.userCerts.forEach(cert => {
        remove(options, function (item) {
          return cert.certType.toString() === item.value
        })
      })
    }

    this.options = options
    this.certType = params.certType || options[0].value

    eventBus.$on('get-token', (value) => {
      this.onGetFinalToken(value)
    })

    this.getCmsData()
  },
  methods: {
    async getCmsData () {
      const cmsData = await getCmsDataFormat()
      this.cmsPageTips = get(cmsData, 'tips') ?? null
    },
    handleFieldValidate (rule, value, callback) {
      validate('certificate', this.form.getFieldsValue(), rule.fullField).then(({ valid, error }) => {
        if (valid) {
          if (rule.fullField === 'certNo') {
            return this.onVerify(value, 2, callback)
          }

          callback()
        } else {
          callback(error)
        }
      })
    },
    async onVerify (value, type, cb) {
      try {
        await verify({
          type,
          value
        })

        cb()
      } catch (err) {
        cb(err.message)
      }
    },
    onSubmit (e) {
      e.preventDefault()

      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          try {
            const { token, finalToken, code, type, value, action, id } = this

            if (!code) {
              this.$error({
                content: `请输入${type === 'mobile' ? '手机' : '邮箱'}动态码！`,
                centered: true
              })
              return
            }

            if (!token) {
              this.$error({
                content: '请拖动滑块完成验证！',
                centered: true
              })
              return
            }

            if (!finalToken) {
              this.$error({
                content: '请点击获取动态码！',
                centered: true
              })
              return
            }

            this.loading = true

            const params = {
              idType: values.certType - 0,
              idCard: values.certNo,
              keyInfo: value,
              verifyCode: code,
              sliderCaptCha: finalToken
            }

            if (id) {
              params.id = id
            }

            await certificate(params)

            this.$success({
              content: `${action === 'add' ? '添加' : '修改'}会员信息成功！`,
              centered: true,
              onOk: () => {
                this.$router.replace('/account')
              }
            })
          } catch (err) {
            this.$refs.verify.refresh()
            this.$error({
              content: err.message,
              centered: true
            })
            this.loading = false
            if (err.code.toString().includes(1000)) {
              this.errCode = err.code
            }
          }
        }
      })
    },
    onCaptchVerify (value) {
      this.token = value
      if (this.errCode.toString().includes(1000)) {
        this.finalToken = value
      }
    },
    onVerificationCodeChange (value) {
      this.code = value
    },
    onVerifyTypeChange (type, value) {
      this.type = type
      this.value = value
    },
    onVerifyTypeError () {
      this.$error({
        content: '对不起，您还未绑定过手机/邮箱，请先完成绑定！',
        centered: true,
        onOk: () => {
          this.$router.replace('/account')
        }
      })
    },
    onGetFinalToken (value) {
      this.finalToken = value
      this.errCode = ''
    }
  }
}
</script>
